/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoPlayStoreSearchRequest model module.
 * @module model/CampaignControllerDtoPlayStoreSearchRequest
 * @version 1.0
 */
class CampaignControllerDtoPlayStoreSearchRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoPlayStoreSearchRequest</code>.
     * @alias module:model/CampaignControllerDtoPlayStoreSearchRequest
     * @param packageName {String} 
     */
    constructor(packageName) { 
        
        CampaignControllerDtoPlayStoreSearchRequest.initialize(this, packageName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, packageName) { 
        obj['packageName'] = packageName;
    }

    /**
     * Constructs a <code>CampaignControllerDtoPlayStoreSearchRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoPlayStoreSearchRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoPlayStoreSearchRequest} The populated <code>CampaignControllerDtoPlayStoreSearchRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoPlayStoreSearchRequest();

            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoPlayStoreSearchRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoPlayStoreSearchRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoPlayStoreSearchRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }

        return true;
    }


}

CampaignControllerDtoPlayStoreSearchRequest.RequiredProperties = ["packageName"];

/**
 * @member {String} packageName
 */
CampaignControllerDtoPlayStoreSearchRequest.prototype['packageName'] = undefined;






export default CampaignControllerDtoPlayStoreSearchRequest;

